import { render, staticRenderFns } from "./OnBoardingForm.vue?vue&type=template&id=539fe7dd&scoped=true&"
import script from "./OnBoardingForm.vue?vue&type=script&lang=js&"
export * from "./OnBoardingForm.vue?vue&type=script&lang=js&"
import style0 from "./OnBoardingForm.vue?vue&type=style&index=0&id=539fe7dd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "539fe7dd",
  null
  
)

export default component.exports